import { Component, OnDestroy, OnInit } from '@angular/core';
import { ParserService } from '../planner-service/parser-service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { getBrokersList } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-broker-setting-list',
  templateUrl: './broker-setting-list.component.html',
  styleUrls: ['./broker-setting-list.component.css']
})
export class BrokerSettingListComponent implements OnInit, OnDestroy {
  brokersSettingList = [];
  search;


  constructor(private parserService:ParserService) { }

  ngOnInit() {
     this.parserService.getBrokerSettingList()
     .pipe(takeUntil(takeUntilDestroyed(this)))
     .subscribe(data=>{
      this.brokersSettingList = data;
    })
  }

  brokerList(key) {
    return key ? getBrokersList[key] : 'N/A';
  }

  ngOnDestroy(): void {
  }
}
